<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">LIST OF VOUCHERS FOR APPROVAL</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-5">
        <v-layout col>
          <v-flex xs12 md3>
            <v-select
              class="mx-2"
              v-model="type_of_voucher"
              dense
              label="Type of Voucher"
              :items="['CV','CKV','FTV']"
              :rules="rules.combobox_rule"
              @change="selected_type"
              outlined
            ></v-select>
            <v-select
              v-model="category_id"
              class="mx-2"
              :items="category_items"
              item-value="id"
              item-text="category"
              label="Category"
              required
              :rules="rules.combobox_rule"
              dense
              @change="selected_category"
              outlined
            ></v-select>
            <v-data-table
              dense
              :headers="headers2"
              :items="vouchered_items"
              height="600"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item }">
                <tr @click="activerow(item)"
                    :class="{ 'info white--text': item.id === selectedDepositId }">
                  <td>
                    {{
                      item.is_approved2 ? (item.is_approved === 1 ? 'APPROVED' : 'Pending CEO') : 'Pending CFO'
                    }}
                  </td>
                  <td>
                    {{ item.acro + '-' + item.voucher_no }}
                  </td>
                  <td>
                    {{ item.bank.bank_code }}
                  </td>
                  <td>
                    {{ item.cheque_no }}
                  </td>
                  <td>
                    {{ item.payee }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 md9 class="mx-2" v-if="data_items.length > 0">
            <v-card>
              <h2>Request Data | Total: P {{ total_amount }}</h2>
              <v-col cols="12" md="12">
                <v-btn class="mx-2" color="success" @click="save_request(1)"
                       v-if="!saving_data">
                  APPROVE VOUCHER
                </v-btn>
                <v-btn class="mx-2" color="error" @click="save_request(0)"
                       v-if="!saving_data">
                  DISAPPROVE VOUCHER
                </v-btn>
                <v-btn class="mx-2" color="warning"
                       @click="type_of_voucher==='CV'?print_data_cash():(type_of_voucher==='CKV'?print_data_cheque():print_data_fund())"
                       v-if="!saving_data">
                  PRINT VOUCHER
                </v-btn>
                <v-btn
                  v-if="type_of_voucher==='FTV' &&!saving_data&&!view_br && existing_voucher.is_inter_company"
                  class="mx-2" color="info" @click="view_br=true">
                  VIEW BOARD RESOLUTION
                </v-btn>
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  v-else
                ></v-progress-circular>
              </v-col>
              <v-data-table
                dense
                :headers="type_of_voucher==='CV'?headers:(type_of_voucher==='CKV'?headers3:headers4)"
                :items="data_items"
                height="600"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item="{ item }">
                  <tr v-if="type_of_voucher==='CV'">
                    <td class="text-center">
                      <div>
                        <v-icon class="mr-2" color="error" @click="remove_from_voucher(item)">
                          {{ icons.mdiDeleteForever }}
                        </v-icon>
                      </div>
                    </td>
                    <td>
                      {{ item.id }}
                    </td>
                    <td>
                      {{ formatDate(item.created_at) }}
                    </td>
                    <td>
                      {{
                        item.request.created_by ? item.request.created_by.last_name + ', ' + item.request.created_by.first_name : ''
                      }}
                    </td>
                    <td>
                      {{ formatDate(item.updated_at) }}
                    </td>
                    <td>
                      {{
                        item.request.approved_by ? item.request.approved_by.last_name + ', ' + item.request.approved_by.first_name : ''
                      }}
                    </td>
                    <td>
                      {{ item.category.category }}
                    </td>
                    <td>
                      {{ item.branch != null ? item.branch.branch_code : '' }}
                    </td>
                    <td>
                      {{ item.particulars.particulars }}
                    </td>
                    <td>
                      {{  (item.particulars_data != null ? ' (' + item.particulars_data.particulars + ') ~ ' : '')+ '' +item.description }}
                    </td>
                    <td>
                      {{ item.credit_to }}
                    </td>
                    <td>
                      {{ item.payment_for }}
                    </td>
                    <td>
                      {{ formatPrice(item.amount) }}
                    </td>
                  </tr>
                  <tr v-if="type_of_voucher==='CKV'">
                    <td class="text-center">
                      <div>
                        <v-icon class="mr-2" color="error" @click="remove_from_voucher(item)">
                          {{ icons.mdiDeleteForever }}
                        </v-icon>
                      </div>
                    </td>
                    <td>
                      {{ item.id }}
                    </td>
                    <td>
                      {{ formatDate(item.created_at) }}
                    </td>
                    <td>
                      {{
                        item.request.created_by ? item.request.created_by.last_name + ', ' + item.request.created_by.first_name : ''
                      }}
                    </td>
                    <td>
                      {{ formatDate(item.updated_at) }}
                    </td>
                    <td>
                      {{
                        item.request.approved_by ? item.request.approved_by.last_name + ', ' + item.request.approved_by.first_name : ''
                      }}
                    </td>
                    <td>
                      {{ item.category.category }}
                    </td>
                    <td>
                      {{ item.branch != null ? item.branch.branch_code : '' }}
                    </td>
                    <td>
                      {{ item.particulars.particulars }}
                    </td>
                    <td>
                      {{  (item.particulars_data != null ? ' (' + item.particulars_data.particulars + ') ~ ' : '')+ '' +item.description }}
                    </td>
                    <td>
                      {{ item.credit_to }}
                    </td>
                    <td>
                      {{ item.payment_for }}
                    </td>
                    <td>
                      {{ item.cheque_date }}
                    </td>
                    <td>
                      {{ item.cheque_no }}
                    </td>
                    <td>
                      {{
                        item.pdc_status === 0 ?
                          'Not Count:' + formatPrice(item.amount) : formatPrice(item.amount)
                      }}
                    </td>
                  </tr>
                  <tr v-if="type_of_voucher==='FTV'">
                    <td class="text-center">
                      <div>
                        <v-icon class="mr-2" color="error" @click="remove_from_voucher(item)">
                          {{ icons.mdiDeleteForever }}
                        </v-icon>
                      </div>
                    </td>
                    <td>
                      {{ item.id }}
                    </td>
                    <td>
                      {{ formatDate(item.created_at) }}
                    </td>
                    <td>
                      {{
                        item.request.created_by ? item.request.created_by.last_name + ', ' + item.request.created_by.first_name : ''
                      }}
                    </td>
                    <td>
                      {{ formatDate(item.updated_at) }}
                    </td>
                    <td>
                      {{
                        item.request.approved_by ? item.request.approved_by.last_name + ', ' + item.request.approved_by.first_name : ''
                      }}
                    </td>
                    <td>
                      {{ item.ftv_from_bank.bank_code + '|' + item.ftv_from_bank.account_no }}
                    </td>
                    <td>
                      {{ item.ftv_to_bank.bank_code + '|' + item.ftv_to_bank.account_no }}
                    </td>
                    <td>
                      {{ item.description }}
                    </td>
                    <td>
                      {{ item.cheque_date }}
                    </td>
                    <td>
                      {{ item.cheque_no }}
                    </td>
                    <td>
                      {{
                        item.pdc_status === 0 ?
                          'Not Count:' + formatPrice(item.amount) : formatPrice(item.amount)
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>

    <v-dialog v-model="view_br" persistent max-width="1000px">
      <v-card v-for="(item, index) in pdf_data"
              :key="item.id || index">
        <v-card-text >
          <ViewBRDialog v-if="item.file" :key="index"  :pdfSrc="item.file"/>
        </v-card-text>
      </v-card>
      <v-btn color="error" @click="view_br = false"> Close</v-btn>
    </v-dialog>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {
  mdiAccountOutline, mdiAccountCashOutline, mdiInformationOutline, mdiPrinter
  , mdiCloudUpload
  , mdiMonitorEye
  , mdiDeleteForever
} from '@mdi/js'
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
import ViewUploadCheque from '@/views/report_interface/vouchers/components/ViewUploadCheque'
import ViewBRDialog from '@/views/report_interface/vouchers/components/ViewBR.vue'

const initialState = () => {
  return {
    key: 0,
    show: false,
    view_br: false,

    type_of_voucher: '',

    saving_data: false,
    printt: false,
    upload: false,
    can_upload: false,
    auto_deb: false,

    alert: false,
    alert_message: '',
    saving_data_request: false,
    alert_request: false,
    alert_message_request: '',
    total_amount: 0,
    headers: [
      {text: 'Action', value: 'last_name', sortable: false},
      {text: 'ID', value: 'tin', sortable: false},
      {text: 'Created', value: 'date_of_deposit', sortable: false},
      {text: 'Created By', value: 'date_of_deposit', sortable: false},
      {text: 'Approved', value: 'date_of_deposit', sortable: false},
      {text: 'Approved By', value: 'date_of_deposit', sortable: false},
      {text: 'Category', value: 'last_name', sortable: false},
      {text: 'Branch', value: 'last_name', sortable: false},
      {text: 'Particulars', value: 'last_name', sortable: false},
      {text: 'Description', value: 'last_name', sortable: false},
      {text: 'Credit To', value: 'last_name', sortable: false},
      {text: 'Payment For', value: 'last_name', sortable: false},
      {text: 'Amount', value: 'last_name', sortable: false},
    ],
    headers2: [
      {text: 'Status', value: 'date_of_deposit', sortable: false},
      {text: 'Voucher#', value: 'date_of_deposit', sortable: false},
      {text: 'Bank', value: 'last_name', sortable: false},
      {text: 'Cheque#', value: 'last_name', sortable: false},
      {text: 'Payee', value: 'tin', sortable: false},
    ],
    headers3: [
      {text: 'Action', value: 'last_name', sortable: false},
      {text: 'ID', value: 'tin', sortable: false},
      {text: 'Created', value: 'date_of_deposit', sortable: false},
      {text: 'Created By', value: 'date_of_deposit', sortable: false},
      {text: 'Approved', value: 'date_of_deposit', sortable: false},
      {text: 'Approved By', value: 'date_of_deposit', sortable: false},
      {text: 'Category', value: 'last_name', sortable: false},
      {text: 'Branch', value: 'last_name', sortable: false},
      {text: 'Particulars', value: 'last_name', sortable: false},
      {text: 'Description', value: 'last_name', sortable: false},
      {text: 'Credit To', value: 'last_name', sortable: false},
      {text: 'Payment For', value: 'last_name', sortable: false},
      {text: 'Schedule', value: 'last_name', sortable: false},
      {text: 'Cheque#', value: 'last_name', sortable: false},
      {text: 'Amount', value: 'last_name', sortable: false},
    ],
    headers4: [
      {text: 'Action', value: 'last_name', sortable: false},
      {text: 'ID', value: 'tin', sortable: false},
      {text: 'Created', value: 'date_of_deposit', sortable: false},
      {text: 'Created By', value: 'date_of_deposit', sortable: false},
      {text: 'Approved', value: 'date_of_deposit', sortable: false},
      {text: 'Approved By', value: 'date_of_deposit', sortable: false},
      {text: 'From Bank', value: 'last_name', sortable: false},
      {text: 'To Bank', value: 'last_name', sortable: false},
      {text: 'Description', value: 'last_name', sortable: false},
      {text: 'Schedule', value: 'last_name', sortable: false},
      {text: 'Cheque#', value: 'last_name', sortable: false},
      {text: 'Amount', value: 'last_name', sortable: false},
    ],
    data_items_originaldata_items_original: [],
    data_items: [],
    uploaded_data_items: [],
    data_items2: [],
    pdf_data: [],
    request_id: '',
    request_items: [],
    category_id: '',
    category_items: [],
    month_of_id: '',
    month_of_items: [],
    allocation_of_fund: '',
    payee: '',
    is_auto_debit: false,
    cheque_no: '',
    cheque_date: '',
    voucher_no: '',
    bank_id: '',
    bank_items: [],
    cheque_items: [],
    vouchered_items: [],
    selectedDepositId: -1,
    has_existing_voucher: false,
    existing_voucher: {},

    can_view_uploaded_cheque: false,
  }
}
export default {
  components: {
    snackBarDialog,
    ViewBRDialog,
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiAccountCashOutline,
        mdiInformationOutline,
        mdiPrinter,
        mdiCloudUpload,
        mdiMonitorEye,
        mdiDeleteForever,
      },
    }
  },
  data() {
    return initialState()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', [
      'employee_id',
      'month_of',
      'address',
      'contact',
      'name',
      'department',
      'position',
    ]),
    ...mapGetters('system_data', [
      'snackbar',
      'snackbar_color',
      'snackbar_text',
      'company_logo',
      'damayan',
      'chapel',
      'factory',
      'coop',
      'printing',
      'accounting',
      'admin',
      'amd',
      'audit',
      'book',
      'creative',
      'ecut',
      'hr',
      'it',
      'prot',
      'trea', 'dave_signature',
      'bod_arroco_signature',
    ]),
    ...mapGetters('system_data', ['foundation', 'glbuild', 'mbai', 'glpi',]),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),

    ...mapActions('cash_vouchers', ['list_of_cash_voucher_for_final_approved_report', 'final_approved_cash_voucher']),
    ...mapActions('cheque_vouchers', ['list_of_cheque_voucher_for_final_approved_report', 'final_approved_cheque_voucher']),
    ...mapActions('fund_transfer_vouchers', ['list_of_fund_transfer_voucher_for_final_approved_report', 'final_approved_fund_voucher',
      'view_ftv_documents',]),

    ...mapActions('request', ['list_of_category_in_a_voucher_per_month']),
    ...mapActions('category', ['list_of_available_for_cash_voucher']),
    ...mapActions('transaction_months', ['list_of_transaction_month']),
    ...mapActions('uploaded_cheque', ['get_uploaded_cheque', 'upload_cheque']),

    ...mapActions('request_data', ['delete_request_data']),
    selected_category() {
      this.vouchered_items = []
      this.data_items = []
      switch (this.type_of_voucher) {
        case "CV":
          this.list_of_cash_voucher_for_final_approved_report({
            employee_id: this.employee_id,
            category_id: this.category_id,
          })
            .then(response => {
              this.vouchered_items = response.data
            })
            .catch(error => {
              console.log(error)
            })
          break
        case "CKV":
          this.list_of_cheque_voucher_for_final_approved_report({
            employee_id: this.employee_id,
            category_id: this.category_id,
          })
            .then(response => {
              this.vouchered_items = response.data
            })
            .catch(error => {
              console.log(error)
            })
          break
        case "FTV":
          this.list_of_fund_transfer_voucher_for_final_approved_report({
            employee_id: this.employee_id,
            category_id: this.category_id,
          })
            .then(response => {
              this.vouchered_items = response.data
            })
            .catch(error => {
              console.log(error)
            })
          break
      }
    },
    formatDate(date) {
      return new Date(date).toISOString().split('T')[0]
    },
    async selected_type(value) {
      this.data_items = []
      this.data_items2 = []
      this.vouchered_items = []
      this.total_amount = '0'
      this.selectedDepositId = -1

      this.category_id = ''
      await this.list_of_category_in_a_voucher_per_month({
        month_of_id: this.month_of_id,
        is_cv: value === 'CV' ? 1 : 0,
        is_ckv: value === 'CKV' ? 1 : 0,
        is_ftv: value === 'FTV' ? 1 : 0,
        employee_id: this.employee_id,
      })
        .then(response => {
          this.category_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
      await this.selected_category()
    },
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    activerow(value) {
      this.existing_voucher = value
      this.data_items = value.request_data
      this.selectedDepositId = value.id
      var tto = 0
      var is_cv = this.type_of_voucher === 'CV'
      this.data_items.forEach(function (item) {
        if (is_cv) {
          tto += parseFloat(item.amount)
        } else {
          if (item.pdc_status >= 1) {
            tto += parseFloat(item.amount)
          }
        }
      })
      this.total_amount = this.formatPrice(tto)
      if (this.existing_voucher.is_inter_company) {
        this.view_ftv_documents({
          ftv_id: this.existing_voucher.id,
        })
          .then(response => {
            this.pdf_data = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    async save_request(status) {
      switch (this.type_of_voucher) {
        case "CV":
          await this.final_approved_cash_voucher({
            id: this.selectedDepositId,
            employee_id: this.employee_id,
            status: status,
          })
            .then((response) => {
              this.change_snackbar({
                show: true,
                color: response.status === 200 ? 'success' : 'error',
                text: response.data,
              })
            })
            .catch(error => {
              console.log(error)
            })
          break
        case "CKV":
          await this.final_approved_cheque_voucher({
            id: this.selectedDepositId,
            employee_id: this.employee_id,
            status: status,
          })
            .then((response) => {
              this.change_snackbar({
                show: true,
                color: response.status === 200 ? 'success' : 'error',
                text: response.data,
              })
            })
            .catch(error => {
              console.log(error)
            })
          break
        case "FTV":
          await this.final_approved_fund_voucher({
            id: this.selectedDepositId,
            employee_id: this.employee_id,
            status: status,
          })
            .then((response) => {
              this.change_snackbar({
                show: true,
                color: response.status === 200 ? 'success' : 'error',
                text: response.data,
              })
            })
            .catch(error => {
              console.log(error)
            })
          break
      }
      await this.selected_category()
    },
    remove_from_voucher(item) {
      if (confirm('PROCEED?')) {
        this.delete_request_data({
          id: item.id,
          is_voucher: 1,
          employee_id: this.employee_id,
        })
          .then(response => {
            var color = 'success'
            if (response.status === 201) {
              color = 'error'
            }
            this.change_snackbar({
              show: true,
              color: color,
              text: response.data,
            })
            this.saving_data = false
            this.selected_type(this.type_of_voucher)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    async print_data_cash() {
      var dave_signature_ = this.dave_signature
      var bod_arroco_signature_ = this.bod_arroco_signature
      this.printt = true
      var imgData = this.company_logo

      var entity = 'GOODLIFE GROUP OF COMPANIES'

      switch (this.existing_voucher.category_id) {
        case 3:
        case 17:
        case 18:
          entity = 'GOODLIFE MEMORIAL CHAPEL CO'
          imgData = this.chapel
          break;
        case 4:
          entity = 'GOODLIFE DAMAYAN INSURANCE AGENCY CO.'
          imgData = this.damayan
          break;
        case 5:
          entity = 'GOODLIFE SAVINGS & CREDIT COOPERATIVE'
          imgData = this.coop
          break;
        case 6:
        case 20:
          entity = 'GOODLIFE WOODEN CASKET FACTORY '
          imgData = this.factory
          break;
        case 7:
        case 21:
          entity = 'GOODLIFE PRINTING PRESS'
          imgData = this.printing
          break;
        case 8:
          entity = 'GOODLIFE COMMUNITY CARES FOUNDATION INC.'
          imgData = this.foundation
          break;
        case 10:
          entity = 'GL BUILDINGS & REALTY INC'
          imgData = this.glbuild
          break;
        case 11:
          entity = 'GOODLIFE MUTUAL BENEFITS ASSOCIATION INC.'
          imgData = this.mbai
          break;
        case 12:
          entity = 'GOODLIFE PLANS INC.'
          imgData = this.glpi
          break;
      }
      var payments_array = []
      var widths = []

      var info_array = []
      var cheque_array = {}
      var voc_no = 'CV#' + this.existing_voucher.acro + '-' + this.existing_voucher.year + '-' + this.existing_voucher.voucher_no

      var damayan_ = this.damayan
      var chapel_ = this.chapel
      var factory_ = this.factory
      var coop_ = this.coop
      var printing_ = this.printing

      widths = [20, 20, 40, 40, 60, 110, 70, 70, 55]
      payments_array.push([
        {text: 'ID', alignment: 'left', style: 'main_info'},
        {text: 'Req. ID', alignment: 'left', style: 'main_info'},
        {text: 'Category', alignment: 'left', style: 'main_info'},
        {text: 'Branch', alignment: 'left', style: 'main_info'},
        {text: 'Particulars', alignment: 'left', style: 'main_info'},
        {text: 'Description', alignment: 'left', style: 'main_info'},
        {text: 'Credit To', alignment: 'left', style: 'main_info'},
        {text: 'Payment For', alignment: 'left', style: 'main_info'},
        {text: 'Amount', alignment: 'left', style: 'main_info'},
      ])
      var data_arr = []
      var status = data_arr.length === 0 ? (this.auto_deb ? 'APPROVED' : 'PENDING') : 'APPROVED'
      var tott = this.total_amount
      this.data_items.forEach(function (item, index, payment) {
        payments_array.push([
          {
            text: item.id,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.request_id,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.category.category,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.branch != null ? item.branch.branch_code : '',
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.particulars.particulars,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:  (item.particulars_data != null ? ' (' + item.particulars_data.particulars + ') ~ ' : '')+ '' +item.description,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.credit_to,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.payment_for,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              item.amount === 0
                ? ''
                : (item.amount / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },
        ])
        if (Object.is(payment.length - 1, index)) {
          // execute last item logic
          payments_array.push([
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: 'TOTAL',
              alignment: 'right',
              style: 'tableExample2',
            },
            {
              text: tott,
              alignment: 'left',
              style: 'tableExample2',
            },
          ])
        }
      })

      info_array = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'BANK: ',
                {
                  text: this.existing_voucher.bank.bank_code,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'MONTH OF: ',
                {
                  text: this.existing_voucher.transaction_month.month_of,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'ACCOUNT NO: ',
                {
                  text: this.existing_voucher.bank.account_no,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'VOUCHER #: ',
                {
                  text: voc_no,
                  fontSize: 15,
                  bold: true,
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'ALLOCATION OF FUND: ',
                {
                  text: this.existing_voucher.allocation_of_fund,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'VOUCHER DATE: ',
                {
                  text: this.existing_voucher.cheque_date,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'CHEQUE #: ',
                {
                  text: this.existing_voucher.cheque_no,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'STATUS: ',
                {
                  text: status,
                  fontSize: 15,
                  bold: true,
                  color: status === 'PENDING' ? 'red' : 'green',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'CHEQUE DATE: ',
                {
                  text: this.existing_voucher.cheque_date,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'PAYEE: ',
                {
                  text: this.existing_voucher.payee,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 60, height: 54, style: 'logo'},
              {
                stack: [
                  entity,
                  {text: this.address, style: 'subheader2'},
                  {
                    text: this.contact,
                    style: 'subheader2',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
              {
                image:
                  this.position === 'ADMIN'
                    ? this.admin
                    : this.position === 'TREASURY'
                      ? this.trea
                      : this.position === 'ACCOUNTING'
                        ? this.accounting
                        : this.position === 'AMD'
                          ? this.amd
                          : this.position === 'PROPERTY CUSTODIAN'
                            ? this.prot
                            : this.position === 'HUMAN RESOURCE'
                              ? this.hr
                              : this.position === 'BOOKKEEPING'
                                ? this.book
                                : this.position === 'CMD'
                                  ? this.accounting
                                  : imgData,
                width: 60,
                height: 54,
                style: 'logo',
              },
            ],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: 'CASH VOUCHER',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                    },
                  },
                ],
              },
            ],
          },
          '__________________________________________________________________________________________________',
          {
            text: 'CHEQUE DETAILS',
            style: {
              fontSize: 8,
              alignment: 'left',
              bold: true,
            },
          },
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: ' '}],
          },
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {
            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0 ? '#CCCCCC' : null
              },
            },
          },
          {
            stack: [
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [
                  {
                    text: 'PROCESSED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'DEPARTMENT RECEIVER',
                    style: 'main_data_2',
                  },
                  {
                    text: 'RECEIVED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.existing_voucher.created_by.last_name + ', ' + this.existing_voucher.created_by.first_name + ' ' + this.existing_voucher.created_by.middle_name,
                    style: 'main_data_2',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.existing_voucher.created_by.employee_position.position,
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'VERIFIED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'AUDITED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    image: dave_signature_,
                    width: 80,
                    height: 40,
                    style: 'logo',
                    alignment: 'left',
                    margin: [0, -20, 0, 0]
                  },
                  {
                    text: '_________________________________________',
                    margin: [190, 15, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ERROL DAVE M. RODA (' + this.existing_voucher.approved_date2 + ')',
                    style: 'main_data_2', margin: [0, -30, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (TREASURY)',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'FINANCE DIRECTOR',
                    style: 'main_data_2', margin: [0, -20, 0, 0]
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'APPROVED BY',
                    style: 'main_data_2', margin: [0, 15, 0, 0]
                  },
                  {
                    text: '_________________________________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    image: bod_arroco_signature_,
                    width: 60,
                    height: 60,
                    style: 'logo',
                    alignment: 'left',
                    margin: [0, -15, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (ACCOUNTING)',
                    style: 'main_data_2',
                    margin: [210, 0, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ALBERT C. ARRORO JR. (' + this.existing_voucher.approved_date + ')',
                    style: 'main_data_2', margin: [0, -40, 0, 0]
                  },
                  {
                    text: '_________________________________________', margin: [0, -15, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'BOARD OF DIRECTOR',
                    style: 'main_data_2', margin: [0, -30, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (FINANCE)',
                    style: 'main_data_2', margin: [0, -1, 0, 0]
                  },
                ],
              },
            ],
          },

          cheque_array,
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: 10,
            columns: [
              {
                text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                fontSize: 9,
                alignment: 'left',
              },
              {image: damayan_, width: 34, height: 20, style: 'logo'},
              {image: chapel_, width: 34, height: 20, style: 'logo'},
              {image: factory_, width: 34, height: 20, style: 'logo'},
              {image: coop_, width: 34, height: 20, style: 'logo'},
              {image: printing_, width: 34, height: 20, style: 'logo'},
              {
                columns: [
                  {
                    text: 'VOUCHER #:',
                    fontSize: 9,
                    bold: true,
                    alignment: 'right',
                  },
                  {
                    text: voc_no + ' (BLUE)',
                    fontSize: 10,
                    bold: true,
                    alignment: 'left',
                  },
                ],
              },
            ],
          }
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          subheader2: {
            fontSize: 10,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 9,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.printt = false
    },
    async print_data_cheque() {
      var dave_signature_ = this.dave_signature
      var bod_arroco_signature_ = this.bod_arroco_signature
      this.printt = true
      var imgData = this.company_logo
      var entity = 'GOODLIFE GROUP OF COMPANIES'

      switch (this.existing_voucher.category_id) {
        case 3:
        case 17:
        case 18:
          entity = 'GOODLIFE MEMORIAL CHAPEL CO'
          imgData = this.chapel
          break;
        case 4:
          entity = 'GOODLIFE DAMAYAN INSURANCE AGENCY CO.'
          imgData = this.damayan
          break;
        case 5:
          entity = 'GOODLIFE SAVINGS & CREDIT COOPERATIVE'
          imgData = this.coop
          break;
        case 6:
        case 20:
          entity = 'GOODLIFE WOODEN CASKET FACTORY '
          imgData = this.factory
          break;
        case 7:
        case 21:
          entity = 'GOODLIFE PRINTING PRESS'
          imgData = this.printing
          break;
        case 8:
          entity = 'GOODLIFE COMMUNITY CARES FOUNDATION INC.'
          imgData = this.foundation
          break;
        case 10:
          entity = 'GL BUILDINGS & REALTY INC'
          imgData = this.glbuild
          break;
        case 11:
          entity = 'GOODLIFE MUTUAL BENEFITS ASSOCIATION INC.'
          imgData = this.mbai
          break;
        case 12:
          entity = 'GOODLIFE PLANS INC.'
          imgData = this.glpi
          break;
      }

      var payments_array = []
      var widths = []
      var info_array = []
      var cheque_array = {}
      var voc_no = 'CKV#' + this.existing_voucher.acro + '-' + this.existing_voucher.year + '-' + this.existing_voucher.voucher_no

      var damayan_ = this.damayan
      var chapel_ = this.chapel
      var factory_ = this.factory
      var coop_ = this.coop
      var printing_ = this.printing


      widths = [20, 40, 40, 60, 110, 70, 50, 40, 55]
      payments_array.push([
        {text: 'Req. ID', alignment: 'left', style: 'main_info'},
        {text: 'Category', alignment: 'left', style: 'main_info'},
        {text: 'Branch', alignment: 'left', style: 'main_info'},
        {text: 'Particulars', alignment: 'left', style: 'main_info'},
        {text: 'Description', alignment: 'left', style: 'main_info'},
        {text: 'Payment For', alignment: 'left', style: 'main_info'},
        {text: 'Schedule', alignment: 'left', style: 'main_info'},
        {text: 'Cheque#', alignment: 'left', style: 'main_info'},
        {text: 'Amount', alignment: 'left', style: 'main_info'},
      ])

      var data_arr = []
      var status = data_arr.length === 0 ? (this.auto_deb ? 'APPROVED' : 'PENDING') : 'APPROVED'
      var tott = this.total_amount
      this.data_items.forEach(function (item, index, payment) {
        payments_array.push([
          {
            text: item.request_id,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.category.category,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.branch != null ? item.branch.branch_code : '',
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.particulars.particulars,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text:  (item.particulars_data != null ? ' (' + item.particulars_data.particulars + ') ~ ' : '')+ '' +item.description,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.payment_for,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.cheque_date,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.cheque_no,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.pdc_status === 0 ? 'Not Count: ' : '') + (item.amount / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
        if (Object.is(payment.length - 1, index)) {
          // execute last item logic
          payments_array.push([
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: 'TOTAL',
              alignment: 'right',
              style: 'tableExample2'
            },
            {
              text: tott,
              alignment: 'left',
              style: 'tableExample2'
            },
          ])
        }
      })

      info_array = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'BANK: ',
                {
                  text: this.existing_voucher.bank.bank_code,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'MONTH OF: ',
                {
                  text: this.existing_voucher.transaction_month.month_of,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'ACCOUNT NO: ',
                {
                  text: this.existing_voucher.bank.account_no,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'VOUCHER #: ',
                {
                  text: voc_no,
                  fontSize: 15,
                  bold: true,
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'ALLOCATION OF FUND: ',
                {
                  text: this.existing_voucher.allocation_of_fund,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'VOUCHER DATE: ',
                {
                  text: this.existing_voucher.voucher_date,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'CHEQUE #: ',
                {
                  text: this.existing_voucher.from_cheque_no + '-' + this.existing_voucher.to_cheque_no,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'STATUS: ',
                {
                  text: status,
                  fontSize: 15,
                  bold: true,
                  color: status === 'PENDING' ? 'red' : 'green',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'CHEQUE STATUS: ',
                {
                  text: this.existing_voucher.is_customize === 1 ? 'CUSTOMIZE CHEQUE' : (this.existing_voucher.from_cheque_no === '0' ? 'AUTO DEBIT' : 'REGULAR'),
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'PAYEE: ',
                {
                  text: this.existing_voucher.payee,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 60, height: 54, style: 'logo'},
              {
                stack: [
                  entity,
                  {text: this.address, style: 'subheader2'},
                  {
                    text: this.contact,
                    style: 'subheader2',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
              {
                image: this.position === 'ADMIN' ? this.admin :
                  (this.position === 'TREASURY' ? this.trea :
                    (this.position === 'ACCOUNTING' ? this.accounting :
                      (this.position === 'AMD' ? this.amd :
                        (this.position === 'PROPERTY CUSTODIAN' ? this.prot :
                          (this.position === 'HUMAN RESOURCE' ? this.hr :
                            (this.position === 'BOOKKEEPING' ? this.book :
                              (this.position === 'CMD' ? this.accounting : imgData))))))),
                width: 60,
                height: 54,
                style: 'logo'
              },
            ],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: 'CHEQUE VOUCHER',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                    },
                  },
                ],
              },
            ],
          },
          '__________________________________________________________________________________________________',
          {
            text: 'CHEQUE DETAILS',
            style: {
              fontSize: 8,
              alignment: 'left',
              bold: true,
            },
          },
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: ' '}],
          },
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {

            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
          {
            stack: [
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [
                  {
                    text: 'PROCESSED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'DEPARTMENT RECEIVER',
                    style: 'main_data_2',
                  },
                  {
                    text: 'RECEIVED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.existing_voucher.created_by.last_name + ', ' + this.existing_voucher.created_by.first_name + ' ' + this.existing_voucher.created_by.middle_name,
                    style: 'main_data_2',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.existing_voucher.created_by.employee_position.position,
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              }, {
                columns: [
                  {
                    text: 'VERIFIED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'AUDITED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    image: dave_signature_,
                    width: 80,
                    height: 40,
                    style: 'logo',
                    alignment: 'left',
                    margin: [0, -20, 0, 0]
                  },
                  {
                    text: '_________________________________________',
                    margin: [190, 15, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ERROL DAVE M. RODA (' + this.existing_voucher.approved_date2 + ')',
                    style: 'main_data_2', margin: [0, -30, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (TREASURY)',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'FINANCE DIRECTOR',
                    style: 'main_data_2', margin: [0, -20, 0, 0]
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'APPROVED BY',
                    style: 'main_data_2', margin: [0, 15, 0, 0]
                  },
                  {
                    text: '_________________________________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    image: bod_arroco_signature_,
                    width: 60,
                    height: 60,
                    style: 'logo',
                    alignment: 'left',
                    margin: [0, -15, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (ACCOUNTING)',
                    style: 'main_data_2',
                    margin: [210, 0, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ALBERT C. ARRORO JR. (' + this.existing_voucher.approved_date + ')',
                    style: 'main_data_2', margin: [0, -40, 0, 0]
                  },
                  {
                    text: '_________________________________________', margin: [0, -15, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'BOARD OF DIRECTOR',
                    style: 'main_data_2', margin: [0, -30, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (FINANCE)',
                    style: 'main_data_2', margin: [0, -1, 0, 0]
                  },
                ],
              },
            ],
          },

          cheque_array,
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: 10,
            columns: [
              {
                text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                fontSize: 9,
                alignment: 'left'
              },
              {image: damayan_, width: 34, height: 20, style: 'logo'},
              {image: chapel_, width: 34, height: 20, style: 'logo'},
              {image: factory_, width: 34, height: 20, style: 'logo'},
              {image: coop_, width: 34, height: 20, style: 'logo'},
              {image: printing_, width: 34, height: 20, style: 'logo'},
              {
                columns: [
                  {
                    text: 'VOUCHER #:',
                    fontSize: 9,
                    bold: true,
                    alignment: 'right',
                  },
                  {
                    text: voc_no + ' (RED)',
                    fontSize: 10,
                    bold: true,
                    alignment: 'left',
                  },
                ],
              },
            ],
          };
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          subheader2: {
            fontSize: 10,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 9,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.printt = false
    },
    async print_data_fund() {
      var dave_signature_ = this.dave_signature
      var bod_arroco_signature_ = this.bod_arroco_signature
      this.printt = true
      var imgData = this.company_logo

      var entity = 'GOODLIFE GROUP OF COMPANIES'

      switch (this.existing_voucher.category_id) {
        case 3:
        case 17:
        case 18:
          entity = 'GOODLIFE MEMORIAL CHAPEL CO'
          imgData = this.chapel
          break;
        case 4:
          entity = 'GOODLIFE DAMAYAN INSURANCE AGENCY CO.'
          imgData = this.damayan
          break;
        case 5:
          entity = 'GOODLIFE SAVINGS & CREDIT COOPERATIVE'
          imgData = this.coop
          break;
        case 6:
        case 20:
          entity = 'GOODLIFE WOODEN CASKET FACTORY '
          imgData = this.factory
          break;
        case 7:
        case 21:
          entity = 'GOODLIFE PRINTING PRESS'
          imgData = this.printing
          break;
        case 8:
          entity = 'GOODLIFE COMMUNITY CARES FOUNDATION INC.'
          imgData = this.foundation
          break;
        case 10:
          entity = 'GL BUILDINGS & REALTY INC'
          imgData = this.glbuild
          break;
        case 11:
          entity = 'GOODLIFE MUTUAL BENEFITS ASSOCIATION INC.'
          imgData = this.mbai
          break;
        case 12:
          entity = 'GOODLIFE PLANS INC.'
          imgData = this.glpi
          break;
      }
      var payments_array = []
      var widths = []
      var info_array = []
      var cheque_array = {}
      var voc_no = 'FTV#' + this.existing_voucher.acro + '-' + this.existing_voucher.year + '-' + this.existing_voucher.voucher_no

      var damayan_ = this.damayan
      var chapel_ = this.chapel
      var factory_ = this.factory
      var coop_ = this.coop
      var printing_ = this.printing


      widths = [20, 90, 90, 70, 70, 50, 40, 50]
      payments_array.push([
        {text: 'Req. ID', alignment: 'left', style: 'main_info'},
        {text: 'From Bank', alignment: 'left', style: 'main_info'},
        {text: 'To Bank', alignment: 'left', style: 'main_info'},
        {text: 'Payment For', alignment: 'left', style: 'main_info'},
        {text: 'Credit to', alignment: 'left', style: 'main_info'},
        {text: 'Schedule', alignment: 'left', style: 'main_info'},
        {text: 'Cheque#', alignment: 'left', style: 'main_info'},
        {text: 'Amount', alignment: 'left', style: 'main_info'},
      ])

      var data_arr = []
      var status = data_arr.length === 0 ? (this.auto_deb ? 'APPROVED' : 'PENDING') : 'APPROVED'
      var tott = this.total_amount
      this.data_items.forEach(function (item, index, payment) {
        payments_array.push([
          {
            text: item.request_id,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.ftv_from_bank.bank_code + '|' + item.ftv_from_bank.account_no,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.ftv_to_bank.bank_code + '|' + item.ftv_to_bank.account_no,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.payment_for,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.credit_to,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.cheque_date,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.cheque_no,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.pdc_status === 0 ? 'Not Count: ' : '') + (item.amount / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
        if (Object.is(payment.length - 1, index)) {
          // execute last item logic
          payments_array.push([
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: ''
            },
            {
              text: 'TOTAL',
              alignment: 'right',
              style: 'tableExample2'
            },
            {
              text: tott,
              alignment: 'left',
              style: 'tableExample2'
            },
          ])
        }
      })

      info_array = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'BANK: ',
                {
                  text: this.existing_voucher.bank.bank_code,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'MONTH OF: ',
                {
                  text: this.existing_voucher.transaction_month.month_of,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'ACCOUNT NO: ',
                {
                  text: this.existing_voucher.bank.account_no,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'VOUCHER #: ',
                {
                  text: voc_no,
                  fontSize: 15,
                  bold: true,
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'ALLOCATION OF FUND: ',
                {
                  text: this.existing_voucher.allocation_of_fund,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'VOUCHER DATE: ',
                {
                  text: this.existing_voucher.voucher_date,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'CHEQUE #: ',
                {
                  text: this.existing_voucher.from_cheque_no + '-' + this.existing_voucher.to_cheque_no,
                  style: 'main_data',
                },
              ],
            },
            {
              style: 'main_info',
              text: [
                'STATUS: ',
                {
                  text: status,
                  fontSize: 15,
                  bold: true,
                  color: status === 'PENDING' ? 'red' : 'green',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'CHEQUE STATUS: ',
                {
                  text: this.existing_voucher.is_customize === 1 ? 'CUSTOMIZE CHEQUE' : (this.existing_voucher.from_cheque_no === '0' ? 'AUTO DEBIT' : 'REGULAR'),
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'PAYEE: ',
                {
                  text: this.existing_voucher.payee,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 60, height: 54, style: 'logo'},
              {
                stack: [
                  entity,
                  {text: this.address, style: 'subheader2'},
                  {
                    text: this.contact,
                    style: 'subheader2',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
              {
                image: this.position === 'ADMIN' ? this.admin :
                  (this.position === 'TREASURY' ? this.trea :
                    (this.position === 'ACCOUNTING' ? this.accounting :
                      (this.position === 'AMD' ? this.amd :
                        (this.position === 'PROPERTY CUSTODIAN' ? this.prot :
                          (this.position === 'HUMAN RESOURCE' ? this.hr :
                            (this.position === 'BOOKKEEPING' ? this.book :
                              (this.position === 'CMD' ? this.accounting : imgData))))))),
                width: 60,
                height: 54,
                style: 'logo'
              },
            ],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: 'FUND TRANSFER VOUCHER',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                    },
                  },
                ],
              },
            ],
          },
          '__________________________________________________________________________________________________',
          {
            text: 'CHEQUE DETAILS',
            style: {
              fontSize: 8,
              alignment: 'left',
              bold: true,
            },
          },
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: ' '}],
          },
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {

            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
          {
            stack: [
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [
                  {
                    text: 'PROCESSED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'DEPARTMENT RECEIVER',
                    style: 'main_data_2',
                  },
                  {
                    text: 'RECEIVED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.existing_voucher.created_by.last_name + ', ' + this.existing_voucher.created_by.first_name + ' ' + this.existing_voucher.created_by.middle_name,
                    style: 'main_data_2',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.existing_voucher.created_by.employee_position.position,
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              }, {
                columns: [
                  {
                    text: 'VERIFIED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'AUDITED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    image: dave_signature_,
                    width: 80,
                    height: 40,
                    style: 'logo',
                    alignment: 'left',
                    margin: [0, -20, 0, 0]
                  },
                  {
                    text: '_________________________________________',
                    margin: [190, 15, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ERROL DAVE M. RODA (' + this.existing_voucher.approved_date2 + ')',
                    style: 'main_data_2', margin: [0, -30, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (TREASURY)',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'FINANCE DIRECTOR',
                    style: 'main_data_2', margin: [0, -20, 0, 0]
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'APPROVED BY',
                    style: 'main_data_2', margin: [0, 15, 0, 0]
                  },
                  {
                    text: '_________________________________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    image: bod_arroco_signature_,
                    width: 60,
                    height: 60,
                    style: 'logo',
                    alignment: 'left',
                    margin: [0, -15, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (ACCOUNTING)',
                    style: 'main_data_2',
                    margin: [210, 0, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'ALBERT C. ARRORO JR. (' + this.existing_voucher.approved_date + ')',
                    style: 'main_data_2', margin: [0, -40, 0, 0]
                  },
                  {
                    text: '_________________________________________', margin: [0, -15, 0, 0]
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'BOARD OF DIRECTOR',
                    style: 'main_data_2', margin: [0, -30, 0, 0]
                  },
                  {
                    text: 'Signature Over Printed Name (FINANCE)',
                    style: 'main_data_2', margin: [0, -1, 0, 0]
                  },
                ],
              },
            ],
          },

          cheque_array,
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: 10,
            columns: [
              {
                text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                fontSize: 9,
                alignment: 'left'
              },
              {image: damayan_, width: 34, height: 20, style: 'logo'},
              {image: chapel_, width: 34, height: 20, style: 'logo'},
              {image: factory_, width: 34, height: 20, style: 'logo'},
              {image: coop_, width: 34, height: 20, style: 'logo'},
              {image: printing_, width: 34, height: 20, style: 'logo'},
              {
                columns: [
                  {
                    text: 'VOUCHER #:',
                    fontSize: 9,
                    bold: true,
                    alignment: 'right',
                  },
                  {
                    text: voc_no + ' (YELLOW)',
                    fontSize: 10,
                    bold: true,
                    alignment: 'left',
                  },
                ],
              },
            ],
          };
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          subheader2: {
            fontSize: 10,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 9,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.printt = false
    },
  },
}
</script>
